export const useRewards = () => {
  const {
    isLoading,
    rewards: rewardsFromApi,
    rewrdsPagination,
  } = storeToRefs(useRewardsStore());

  async function fetchRewardsFromApi(
    status: string = 'available',
    type: string = '',
    page: number = 1,
  ) {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;

    try {
      const { ApiService } = useApiService();

      if (type === 'all') {
        type = '';
      }

      await ApiService.get(
        `/bff/gamification/rewards?status=${status}&type=${type}&page=${page}&per_page=8`,
      )
        .then(({ data }) => {
          if (status === 'available') {
            rewardsFromApi.value.available = data.data;
            rewrdsPagination.value.available = {
              current_page: data.current_page,
              from: data.from,
              last_page: data.last_page,
              per_page: data.per_page,
              to: data.to,
              total: data.total,
              filter: type || 'all',
            };
          } else {
            rewardsFromApi.value.finisheds = data.data;
            rewrdsPagination.value.finisheds = {
              current_page: data.current_page,
              from: data.from,
              last_page: data.last_page,
              per_page: data.per_page,
              to: data.to,
              total: data.total,
              filter: type || 'all',
            };
          }
        })
        .catch((error) => {
          console.error('fetchRewardsFromApi error: ', error);
        })
        .finally(() => {
          isLoading.value = false;
        });
    } catch (err) {
      console.error('fetchRewardsFromApi err: ', err);
      isLoading.value = false;
    }
  }

  async function redeemReward(rewardId: number) {
    const { ApiService } = useApiService();

    const response = await ApiService.post(`/bff/gamification/redeem`, {
      reward_id: rewardId,
    });

    if (response?.data?.success) {
      rewardsFromApi.value.available = rewardsFromApi.value.available.map(
        (reward) => {
          if (reward.id === rewardId) {
            return {
              ...reward,
              status: 'redeemed',
              updated_at: new Date().toISOString(),
            };
          }

          return reward;
        },
      );

      const { getWallet } = useWalletStore();

      await getWallet();
    }

    return response;
  }

  return {
    fetchRewardsFromApi,
    rewardsFromApi,
    redeemReward,
    isLoadingRewards: isLoading,
    rewrdsPagination,
  };
};
